module.exports = __webpack_public_path__ + "static/logos-09-226962b37d1031e926d268e369ba7d8e.png";